module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/whatsapp.8d357518.svg";